import React, { useEffect, useState } from "react";

const COOKIE_NAME = "vpc_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_NAME);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_NAME, "accepted");
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem(COOKIE_NAME, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-wrapper">
      <div className="cookie-consent-card">
        <h4>🍪 We respect your privacy</h4>

        <p>
          We use essential cookies to ensure proper website functionality and
          improve performance. No third-party tracking is used.
        </p>

        <div className="cookie-actions">
          <button className="cookie-btn reject" onClick={rejectCookies}>
            Reject
          </button>
          <button className="cookie-btn accept" onClick={acceptCookies}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
